import { useState } from 'react';
import { Button, Group, Stack, Text } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import { useAppUser } from '../../hooks/useAppUser';
import { EditableAvatar } from './EditableAvatar';
import { ProfileIdentityModal } from './ProfileIdentityModal';

/**
 * The Account section's name-and-photo row. Self-persisting through the
 * editor's own endpoints, so it stays out of the page's unsaved-changes
 * snapshot. Values come from useAppUser (no mount fetch of its own) and
 * refresh in place when the editor saves.
 */
export const NameAndPhotoPreference = () => {
  const { user } = useAppUser();
  const [editing, setEditing] = useState(false);

  const displayName = user?.displayName ?? undefined;
  const photoURL = user?.photoURL ?? undefined;

  return (
    <Stack gap="md">
      <Text size="sm" c="dimmed">
        How you appear on your public cookbook and on recipes you share.
      </Text>

      <Group gap="md" wrap="nowrap" justify="space-between">
        <Group gap="md" wrap="nowrap" style={{ minWidth: 0 }}>
          <EditableAvatar
            photoURL={photoURL}
            displayName={displayName}
            size={48}
            onClick={() => setEditing(true)}
          />
          <Text fw={500} style={{ wordBreak: 'break-word' }}>
            {displayName || (
              <Text span c="dimmed" fs="italic" inherit>
                No name set
              </Text>
            )}
          </Text>
        </Group>
        <Button
          variant="light"
          size="sm"
          leftSection={<IconPencil size={16} />}
          onClick={() => setEditing(true)}
          style={{ flexShrink: 0 }}
        >
          Edit
        </Button>
      </Group>

      <ProfileIdentityModal
        opened={editing}
        onClose={() => setEditing(false)}
        displayName={displayName}
        photoURL={photoURL}
      />
    </Stack>
  );
};
